import { useLocation } from "react-router-dom";

// Routes that render a full-screen, chrome-free utility surface.
const HIDDEN_FOOTER_PATHS = new Set(["/arsenal", "/guide", "/demo", "/bentley", "/brief", "/foyer-preview"]);

export const ComplianceFooter = () => {
  const { pathname } = useLocation();
  if (HIDDEN_FOOTER_PATHS.has(pathname)) return null;
  return (
    <div
      className="w-full border-t border-white/5 bg-[#060B14]/80 px-6 py-5 mt-auto"
      data-testid="compliance-footer"
    >
      <p className="max-w-5xl mx-auto text-[10px] sm:text-xs leading-relaxed text-slate-500 text-center">
        <span className="hud-label text-[9px] mr-2">Disclaimer ·</span>
        Wingman Alfred™ is an automation service provider. We do not guarantee income, results,
        or specific financial outcomes. Success depends on individual effort, market conditions,
        and adherence to the 7-hour activation protocol. Alfred is an AI assistant designed for
        technical implementation and training support.
      </p>
    </div>
  );
};
